import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contractNumberPipe'
})
export class ContractNumber implements PipeTransform {
  transform(value: string): string {
    const contractNumVal = value.replace(/"/g, '').replace(/=/g, '');
    return contractNumVal;
  }
}
